import colors from 'styles/themes/wikifactory/styles/colors';

const rfqStates = {
  DRAFT: {
    title: 'Draft',
    color: colors.wfGrey,
  },
  INCOMPLETE: {
    title: 'RFQ Incomplete',
    color: colors.wfOrange,
  },
  UNDER_REVIEW: {
    title: 'Evaluating Part',
    color: colors.wfGreen,
  },
  RESOLVING_ISSUE: {
    title: 'Resolving Issues',
    color: colors.wfOrange,
  },
  INITIATED: {
    title: 'Awaiting Quotes',
    color: colors.wfGreen,
  },
  QUOTED: {
    title: 'Quoted',
    color: colors.wfGreen,
  },
  ASSIGNED: {
    title: 'Assigned to Manufacturer(s)',
    color: colors.wfGreen,
  },
  AWARDED: {
    title: 'Order placed',
    color: colors.wfBlue,
  },
  CANCELLED: {
    title: 'Cancelled',
    color: colors.wfGrey,
  },
};

export type RFQState = keyof typeof rfqStates;

export default rfqStates;
